import {useEffect, useRef, useState} from "react";
import ColorSchemesExample from "../../gear/navbar/BasicExample";
import "../../index.css"
import logo from "../../logo.png";

function Alpha() {
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const messagesEndRef = useRef(null);

    const handleInputChange = (event) => {
        setMessage(event.target.value);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        setMessage("");
        // Add user message to the messages array
        const newMessage = { text: message, sender: "user" };
        setMessages([...messages, newMessage]);

        try {
            const response = await fetch("/api/predict" , {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*'
                },
                body: JSON.stringify({ sid: "0", messages: [...messages, newMessage] }),
            });
            console.log(response);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            // Add chatbot response to the messages array
            const lastChatbotMessage = data[data.length - 1];
            setMessages([...messages, newMessage, { text: lastChatbotMessage, sender: "chatbot" }]);

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    return (
        <div className="container-alpha">
            <ColorSchemesExample />
            <div className="mid-container">
                <img className="logo" src={logo} alt="logo" />
            </div>
            <div className="content">
                <form onSubmit={handleFormSubmit}>
                    <input
                        type="text"
                        className="input-box"
                        placeholder="Hail the machine: привет"
                        value={message}
                        onChange={handleInputChange}
                    />
                </form>
                <div className="chat-window">
                    {messages.map((msg, index) => (
                        <div
                            key={index}
                            className={`message-container ${
                                msg.sender === "user" ? "right" : "left"
                            }`}
                        >
                            <div className="message">{msg.text}</div>
                        </div>
                    ))}
                    <div ref={messagesEndRef} />
                </div>
            </div>
            <div className="footer">Pure RuDialoGPT3-M rev. 0.3 (default tokenizer)</div>
        </div>
    );
}

export default Alpha;